import React from 'react';
import { FormattedMessage } from 'react-intl';

import ActionModal from 'components/Shared/ActionModal/ActionModal';

export interface Props {
  hide: () => void;
  onContinue: () => void;
  nextPaymentDate: string;
  isPaid?: boolean;
  companyLocale: string;
  featureFlags?: any;
}

const AutopayCancelModal: React.FC<Props> = ({
  hide,
  onContinue,
  nextPaymentDate,
  isPaid = false,
}) => {
  return (
    <ActionModal
      hide={hide}
      onContinue={onContinue}
      headerIntl={{
        id: 'AUTOPAY_CANCEL_MODAL_HEADER',
        defaultMessage: 'Cancel autopay for this business?',
      }}
      continueIntl={{
        id: 'AUTOPAY_CANCEL_MODAL_UNSUBSCRIBE_BTN',
        defaultMessage: 'Yes, cancel autopay',
      }}
      cancelIntl={{
        id: 'AUTOPAY_CANCEL_MODAL_BACK_BUTTON',
        defaultMessage: 'Don’t cancel autopay',
      }}
      hideOnContinueFinish={false}
    >
      <div>
        {isPaid ? (
          <React.Fragment>
            <div style={{ display: 'block' }}>
              <FormattedMessage
                id="AUTOPAY_CANCEL_MODAL_BODY1"
                defaultMessage={'The next autopay is {0}'}
                values={{
                  0: nextPaymentDate,
                }}
              />
            </div>
            <FormattedMessage
              id="AUTOPAY_CANCEL_MODAL_BODY2"
              defaultMessage="If you cancel, be sure to pay any outstanding invoices or reschedule autopay."
            />
          </React.Fragment>
        ) : (
          <FormattedMessage
            id="SCHEDULE_PAY_CANCEL_MODAL_BODY"
            defaultMessage="If you cancel, you can sign in again to pay or reschedule it."
          />
        )}
      </div>
    </ActionModal>
  );
};

export default AutopayCancelModal;
